module.exports = __webpack_public_path__ + "static/media/isdoctorplan-obgyn1@3x.5fc9ff53.png";